<template>
  <div class="request-list-container">
    <div class="request-list-wrapper">
      <div class="request-table">
        <div class="request-table-list request-table-border table-flex">
          <div class="column10">
            REQUEST ID
            <span class="small-text cursor-pointer"
              ><i
                :class="
                  `fas fa-long-arrow-alt-${
                    $get($store, 'state.myRequest.order_by') == 'code' &&
                    $get($store, 'state.myRequest.order_short') == 'desc'
                      ? 'up'
                      : 'down'
                  }`
                "
                @click="short('code')"
              ></i
            ></span>
          </div>
          <div class="column15">
            Nama Vendor
            <span class="small-text cursor-pointer"
              ><i
                :class="
                  `fas fa-long-arrow-alt-${
                    $get($store, 'state.myRequest.order_by') == 'nama_vendor' &&
                    $get($store, 'state.myRequest.order_short') == 'desc'
                      ? 'up'
                      : 'down'
                  }`
                "
                @click="short('nama_vendor')"
              ></i
            ></span>
          </div>
          <div class="column20 ml20">
            Tipe Request
            <span class="small-text cursor-pointer"
              ><i
                :class="
                  `fas fa-long-arrow-alt-${
                    $get($store, 'state.myRequest.order_by') == 'type' &&
                    $get($store, 'state.myRequest.order_short') == 'desc'
                      ? 'up'
                      : 'down'
                  }`
                "
                @click="short('type')"
              ></i
            ></span>
          </div>
          <div class="column15">
            Tanggal Request
            <span class="small-text cursor-pointer"
              ><i
                :class="
                  `fas fa-long-arrow-alt-${
                    $get($store, 'state.myRequest.order_by') == 'createdAt' &&
                    $get($store, 'state.myRequest.order_short') == 'desc'
                      ? 'up'
                      : 'down'
                  }`
                "
                @click="short('createdAt')"
              ></i
            ></span>
          </div>
          <div class="column15">
            Tgl Terakhir Diubah
            <span class="small-text cursor-pointer"
              ><i
                :class="
                  `fas fa-long-arrow-alt-${
                    $get($store, 'state.myRequest.order_by') == 'updatedAt' &&
                    $get($store, 'state.myRequest.order_short') == 'desc'
                      ? 'up'
                      : 'down'
                  }`
                "
                @click="short('updatedAt')"
              ></i
            ></span>
          </div>
          <div class="column15 text-center">
            Status
            <span class="small-text cursor-pointer"
              ><i
                :class="
                  `fas fa-long-arrow-alt-${
                    $get($store, 'state.myRequest.order_by') == 'status' &&
                    $get($store, 'state.myRequest.order_short') == 'desc'
                      ? 'up'
                      : 'down'
                  }`
                "
                @click="short('status')"
              ></i
            ></span>
          </div>
          <div class="column15 text-center">
            CSI Score
            <span class="small-text cursor-pointer"
              ><i
                :class="
                  `fas fa-long-arrow-alt-${
                    $get($store, 'state.myRequest.order_by') == 'csi' &&
                    $get($store, 'state.myRequest.order_short') == 'desc'
                      ? 'up'
                      : 'down'
                  }`
                "
                @click="short('csi')"
              ></i
            ></span>
          </div>
          <div class="column5">Aksi</div>
        </div>
        <div
          class="request-table-list cursor-pointer"
          v-for="(item, index) in $store.state.myRequest.list"
          :key="index"
        >
          <div class="table-flex mb10" @click="showDetail(item.id)">
            <div class="column10">{{ item.code.toUpperCase() }}</div>
            <div class="column15 all-column">{{ item.nama_vendor }}</div>
            <div class="column20 ml20">{{ requestType(item.type) }}</div>
            <div class="column15">{{ formatDate(item.createdAt) }}</div>
            <div class="column15">{{ formatDate(item.updatedAt) }}</div>
            <div class="column15">
              <div class="active-box col-elipsis all-column">
                {{ requestStatus(item.status) }}
              </div>
            </div>
            <div class="column15 csiToolTip">
              <span class="csiToolTiptext">{{ requestCsi(item.csi) }}</span>
              <div
                class="csi-box col-elipsis all-column "
                v-if="item.status == 5 || item.status == 13"
              >
                <div>
                  <span
                    :class="
                      kinerjaPoRating(item.csi, 1)
                        ? 'star-active'
                        : 'star-deactive'
                    "
                    >&#9733;</span
                  >
                  <span
                    :class="
                      kinerjaPoRating(item.csi, 2)
                        ? 'star-active'
                        : 'star-deactive'
                    "
                    >&#9733;</span
                  >
                  <span
                    :class="
                      kinerjaPoRating(item.csi, 3)
                        ? 'star-active'
                        : 'star-deactive'
                    "
                    >&#9733;</span
                  >
                  <span
                    :class="
                      kinerjaPoRating(item.csi, 4)
                        ? 'star-active'
                        : 'star-deactive'
                    "
                    >&#9733;</span
                  >
                  <span
                    :class="
                      kinerjaPoRating(item.csi, 5)
                        ? 'star-active'
                        : 'star-deactive'
                    "
                    >&#9733;</span
                  >
                </div>
              </div>
            </div>
            <div class="column5 table-flex">
              <i
                class="far fa-eye icon-hover"
                @click="detail(item.id, item.status, item.type)"
              ></i>
              <i
                class="far fa-star ml10 icon-hover"
                v-if="item.status == 5 || item.status == 13"
                @click="
                  submitCsi(item.id, item.status, item.type, item.user_id)
                "
              ></i>
            </div>
          </div>
          <div v-if="detailIndex == item.id">
            <div
              class="table-flex"
              v-for="(subItem, i) in item.approval"
              :key="i"
            >
              <div class="column10">
                <div class="box-green">{{ i + 1 }}</div>
              </div>
              <div class="column20">{{ requestStatus(subItem.status) }}</div>
              <div class="column5">-</div>
              <div class="column60 all-column">
                {{ subItem.desc && checkString(subItem.desc) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="request-pagination">
        <div class="mlp-pagination-wrapper-level1">
          <b-pagination
            aria-controls="isupplier-table"
            v-model="page"
            :total-rows="totalItems"
            :per-page="perPage"
            align="fill"
            class="mlp-pagination"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      requests: [],
      detailIndex: null,
    }
  },
  created() {
    this.getRequest()
  },
  computed: {
    page: {
      get: function() {
        return this.$store.state.myRequest.page
      },
      set: function(newValue) {
        this.$store.dispatch('myRequest/setPagination', {
          name: 'page',
          value: newValue,
        })
      },
    },
    totalItems: function() {
      return this.$store.state.myRequest.totalItems
    },
    perPage: function() {
      return this.$store.state.myRequest.perPage
    },
  },
  methods: {
    checkString(value) {
      if (typeof value == 'string') {
        if (value.indexOf('undefined') >= 0) {
          return value.replace(/undefined/g, 'Tidak ada Catatan')
        }
        if (value.indexOf('Vendor telah terdaftar di SAP "done"') >= 0) {
          return value.replace(
            /Vendor telah terdaftar di SAP "done"/g,
            'Vendor telah terdaftar di SAP'
          )
        }
      }
      return value
    },
    async detail(id, status, type, session) {
      if (type == 2 || type == 3 || type == 4 || type == 10 || type == 7) {
        if (type == 2) {
          await this.$router.push({
            path: `/myrequest/review/extend-to-sap/${id}`,
          })
        }
        if (type == 3) {
          await this.$router.push({
            path: `/myrequest/review/block-vendor/${id}`,
          })
        }
        if (type == 4) {
          await this.$router.push({
            path: `/myrequest/review/unblock-vendor/${id}`,
          })
        }

        if (type == 10 || type == 7) {
          this.$router.push({
            path: `/myrequest/k3l-validation/${id}/${status}`,
          })
        }
      } else {
        if (this.requestListValidation(status)) {
          await this.$router.push(`/myrequest/validation/${id}/${status}`)
        } else if (status == 3) {
          this.$router.push({
            path: `/myrequest/update-vendor/${id}`,
          })
        } else if (status == 6) {
          this.$store.dispatch('myRequest/requestDetail', id)
          this.$store.commit(
            'SET_NOTIF',
            'Silahkan cek link di email untuk mengisi data.'
          )
        } else if (status == 14) {
          await this.$store.commit(
            'SET_NOTIF',
            'Vendor telah dihapus, tidak ada data'
          )
        } else {
          this.$router.push({ path: `/myrequest/detail/${id}` })
        }
      }
    },
    getRequest() {
      this.$store.dispatch('myRequest/getRequest')
    },
    showDetail(value) {
      if (this.detailIndex == null || this.detailIndex != value) {
        this.detailIndex = value
      } else {
        this.detailIndex = null
      }
    },
    async short(order) {
      await this.$store.commit('myRequest/SET_ORDER_SHORT')
      await this.$store.commit('myRequest/SET_DATA', {
        name: 'order_by',
        value: order,
      })
      await this.getRequest()
    },
    submitCsi(id, status, type, userid) {
      this.$router.push(`/myrequest/csi/${id}/${type}/${status}/${userid}`)
    },
  },
}
</script>
